import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

const onColumnHeaderWidthsUpdatedMutator: (
    senderColumnWidth: number,
    subjectColumnWidth: number,
    receivedColumnWidth: number
) => void = mutatorAction(
    'onColumnHeaderWidthsUpdated',
    (senderColumnWidth: number, subjectColumnWidth: number, receivedColumnWidth: number): void => {
        getStore().senderColumnWidth = senderColumnWidth;
        getStore().subjectColumnWidth = subjectColumnWidth;
        getStore().receivedColumnWidth = receivedColumnWidth;
    }
);
export default onColumnHeaderWidthsUpdatedMutator;
